import { useWebContext } from '@/resources/hooks/useWebContext';

import { humanizeDate, sumHoursToMinute } from '../../../../../../services/dates';

interface Props {
  pickupAt: string | null;
  arrow?: boolean;
  showTime?: boolean;
  fromPayment?: boolean;
}
function RenderPickupAt({ pickupAt, arrow = false, showTime = true, fromPayment = false }: Props) {
  const { day, time } = humanizeDate(pickupAt, fromPayment);
  const { shop } = useWebContext();

  return (
    <>
      {pickupAt && (
        <>
          {fromPayment ? (
            <>
              <span>
                {' '}
                {day}. Horário: {time}
              </span>
              {shop.show_full_range && (
                <>
                  <span> às {sumHoursToMinute(pickupAt, shop.interval)}</span>
                </>
              )}
            </>
          ) : (
            <>
              {arrow ? '>' : ''}
              <span> {day}</span>
              {showTime && <span>, {time}</span>}

              {shop.show_full_range && (
                <>
                  <span> às {sumHoursToMinute(pickupAt, shop.interval)}</span>
                </>
              )}
            </>
          )}
        </>
      )}

      {!pickupAt && '---'}
    </>
  );
}

export default RenderPickupAt;
